// src/config/notifications.ts
//
// Shared notification bell tuning constants.

/**
 * Bounded polling interval (ms) for the notification bell's unread count and
 * inbox list in RP/BFF mode. Reuses the value the bell previously used for its
 * SSE-failure polling fallback (60s) — deliberately conservative, not
 * aggressive. PR-N2 will replace polling with a same-origin BFF SSE proxy.
 */
export const NOTIFICATION_POLL_INTERVAL_MS = 60_000;
